import CustomMarkerClusterer from "./CustomMarkerClusterer";
import SuperClusterAlgorithm from "./SuperClusterAlgorithm";
import superRanderer from "./superRanderer";
import { convertNumberToShort } from "../../utils";
import { myPolygon } from "./CustomMarkerClusterer";
var cluster;
var markers = [];
var strictBounds;
export const addMarkers = (map, props, result, data, currentMapRef) => {
    strictBounds = new window.google.maps.LatLngBounds(
        new window.google.maps.LatLng(result[0].geometry.viewport.south, result[0].geometry.viewport.west),
        new window.google.maps.LatLng(result[0].geometry.viewport.north, result[0].geometry.viewport.east)
    );

    var minZoomLevel = 5;

    //addMarkersData(map, data, props);
    window.google.maps.event.clearListeners(map, "idle");
    // Limit the zoom level
    window.google.maps.event.addListener(map, "idle", async () => {
        const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
        cluster?.clearMarkers();
        function setMapOnAll(map) {
            for (let i = 0; i < markers.length; i++) {
                markers[i].setMap(map);
            }
        }
        setMapOnAll(null);
        markers = [];

        strictBounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(map.getBounds().getSouthWest().lat(), map.getBounds().getSouthWest().lng()),
            new window.google.maps.LatLng(map.getBounds().getNorthEast().lat(), map.getBounds().getNorthEast().lng())
        );

        const filterdMarker = data.filter(({ propertyLat, propertyLng, listRent }) => {
            const position = new window.google.maps.LatLng(propertyLat, propertyLng);
            const isWithinBounds = strictBounds.contains(position);
            if (isWithinBounds && listRent) {
                return true;
            }
            return false;
        });

        props.onMapLocationChange(filterdMarker);

        markers = filterdMarker.map((listing) => {
            const priceTag = document.createElement("div");

            priceTag.className = "price-tag";
            priceTag.textContent = convertNumberToShort(listing.listRent, "$");

            const marker = new AdvancedMarkerElement({
                map,
                position: { lat: listing.propertyLat, lng: listing.propertyLng },
                content: priceTag,
            });
            marker.addListener("click", ({ domEvent, latLng }) => {
                const { target } = domEvent;
                map.setCenter(latLng);
                map.setZoom(18);
                props.onMarkerSelect(listing);
            });
            return marker;
        });

        cluster = new CustomMarkerClusterer({
            markers,
            map,
            algorithm: new SuperClusterAlgorithm({ radius: 200, minPoints: 3 }),
            renderer: new superRanderer(AdvancedMarkerElement),
        });
        cluster.renderData();

        // if (map.getZoom() < minZoomLevel) {
        //     map.setZoom(minZoomLevel);
        // }

        //map.setZoom(result[0].geometry.viewport);

        const clearBoundry = (name) => {
            const featureLayer = currentMapRef.current?.getFeatureLayer(name);
            featureLayer.style = null;
        };
        clearBoundry("POSTAL_CODE");
        clearBoundry("LOCALITY");
        clearBoundry("ADMINISTRATIVE_AREA_LEVEL_1");
        const addBoundry = (name, placeId) => {
            const featureLayer = currentMapRef.current?.getFeatureLayer(name);
            const styleFill = {
                strokeColor: "#810FCB",
                strokeOpacity: 1.0,
                strokeWeight: 1.0,
                fillColor: "green",
                fillOpacity: 0.1,
            };
            featureLayer.style = (params) => {
                if (params.feature.placeId === placeId) {
                    return styleFill;
                }
            };
            featureLayer.addListener("polygoncomplete", (data) => {});
        };

        let lastLocation = localStorage.getItem("lastLocation");
        if (lastLocation) {
            lastLocation = JSON.parse(lastLocation);
            addBoundry("POSTAL_CODE", lastLocation.place_id);
            addBoundry("LOCALITY", lastLocation.place_id);
            addBoundry("ADMINISTRATIVE_AREA_LEVEL_1", lastLocation.place_id);
        }
    });

    window.google.maps.event.addListener(map, "zoom_changed", function () {
        localStorage.setItem("map-zoom-level", JSON.stringify(map.getZoom()));
        myPolygon?.setMap(null);
    });
};

export const addMarkersData = async (map, data, props) => {
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
    cluster?.clearMarkers();
    function setMapOnAll(map) {
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(map);
        }
    }
    setMapOnAll(null);
    markers = [];

    strictBounds = new window.google.maps.LatLngBounds(
        new window.google.maps.LatLng(map.getBounds().getSouthWest().lat(), map.getBounds().getSouthWest().lng()),
        new window.google.maps.LatLng(map.getBounds().getNorthEast().lat(), map.getBounds().getNorthEast().lng())
    );

    const filterdMarker = data.filter(({ propertyLat, propertyLng, listRent }) => {
        const position = new window.google.maps.LatLng(propertyLat, propertyLng);
        const isWithinBounds = strictBounds.contains(position);
        if (isWithinBounds && listRent) {
            return true;
        }
        return false;
    });

    props.onMapLocationChange(filterdMarker);

    markers = filterdMarker.map((listing) => {
        const priceTag = document.createElement("div");

        priceTag.className = "price-tag";
        priceTag.textContent = convertNumberToShort(listing.listRent, "$");

        const marker = new AdvancedMarkerElement({
            map,
            position: { lat: listing.propertyLat, lng: listing.propertyLng },
            content: priceTag,
        });
        marker.addListener("click", ({ domEvent, latLng }) => {
            const { target } = domEvent;
            map.setCenter(latLng);
            map.setZoom(18);
            props.onMarkerSelect(listing);
        });
        return marker;
    });

    cluster = new CustomMarkerClusterer({
        markers,
        map,
        algorithm: new SuperClusterAlgorithm({ radius: 350, minPoints: 1 }),
        renderer: new superRanderer(AdvancedMarkerElement),
    });
    cluster.renderData();
};
